import { render, staticRenderFns } from "./CommissionPlanColumn.vue?vue&type=template&id=f06e4d46&scoped=true&"
import script from "./CommissionPlanColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionPlanColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06e4d46",
  null
  
)

export default component.exports